import { render, staticRenderFns } from "./DeliveryTruckIcon.vue?vue&type=template&id=c2aeea5c"
import script from "./DeliveryTruckIcon.vue?vue&type=script&lang=js"
export * from "./DeliveryTruckIcon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports